export default {
    features: ["germanVatId", "documents"],
    taxRates: [
        {value: 'tax_0', text: "0 %"},
        {value: 'tax_7', text: "7 %"},
        {value: 'tax_78', text : "7,8 %"},
        {value: 'tax_19', text: "19 %"},
        {value: 'tax_95', text: "9 %"}
    ],
    defaultTaxRate: 'tax_19',
    shopUrl: 'https://meck-schweizer.myshopify.com/',
    shopTitle: "Marktregio",
    platformOwner: 'Meck Schweizer',
    firebaseConfig: {
        apiKey: "AIzaSyCJ1Ob9JagN5n5BWoKi1FDVR8oFcT3x0ag",
        authDomain: "pommernarche-shopify.firebaseapp.com",
        projectId: "pommernarche-shopify",
        storageBucket: "pommernarche-shopify.appspot.com",
        messagingSenderId: "894682705763",
        appId: "1:894682705763:web:937ee18bbcb0ce3e3d6d56",
        measurementId: "G-ZPD03KD7NS"
    },
    apiHost: 'https://shopify-pscpydqyta-ey.a.run.app/',
    googleMapsApiKey: "AIzaSyB-XIRpRFdBwc6xbdC42UEnnyomg7eberk",
    regions: [
        "Mecklenburg-Vorpommern",
        "Brandenburg",
        "Baden-Württemberg",
        "Bayern",
        "Berlin",
        "Bremen",
        "Hamburg",
        "Hessen",
        "Niedersachsen",
        "Nordrhein-Westfalen",
        "Rheinland-Pfalz",
        "Saarland",
        "Sachsen",
        "Sachsen-Anhalt",
        "Schleswig-Holstein",
        "Thüringen",
    ]
}